const config = {
  statusColor: '#5CE592',
  statusInactiveColor: '#FC6F6F',
  unMaskColor: '#c7c7c7',
  unMaskTime: 1400,
  zxcvbnSrc: 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/1.0/zxcvbn.min.js',
  strengthLang: ['Weak', 'Okay', 'Good', 'Strong', 'Great']
};

export default config;